export const FORNECEDOR_ORIGEM = {
  IMPORTADO: 'importado',
  AUTOCADASTRO: 'autocadastro',
  ADMIN: 'admin',
} as const;

export type FornecedorOrigem = typeof FORNECEDOR_ORIGEM[keyof typeof FORNECEDOR_ORIGEM];

export const FORNECEDOR_STATUS = {
  PENDENTE: 'pendente',
  APROVADO: 'aprovado',
  REJEITADO: 'rejeitado',
} as const;

export type FornecedorStatus = typeof FORNECEDOR_STATUS[keyof typeof FORNECEDOR_STATUS];
